import { Classes } from '../Classes/Classes'

export const ClassesPage = () => <Classes />
